import type { SxProps, Theme } from "@mui/material/styles";

export const main: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  width: "100%",
  bgcolor: "background.default",
  boxSizing: "border-box",
};

export const content: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.75),
  px: { xs: 2, sm: 4 },
  py: { xs: 2, sm: 4 },
  width: "100%",
  maxWidth: 1200,
  mx: "auto",
  boxSizing: "border-box",
});

export const quickOrderSection: SxProps<Theme> = {
  minWidth: 0,
};

export const columns: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: { xs: "1fr", lg: "1fr 400px" },
  gap: theme.spacing(2.5),
  alignItems: "start",
});

export const leftColumn: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
  minWidth: 0,
});

export const rightColumn: SxProps<Theme> = {
  minWidth: 0,
  width: "100%",
  maxWidth: { lg: 400 },
};
